import { render, staticRenderFns } from "./ButtonGroupHorizontal.vue?vue&type=template&id=6a7c8301&scoped=true&"
import script from "./ButtonGroupHorizontal.vue?vue&type=script&lang=js&"
export * from "./ButtonGroupHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGroupHorizontal.vue?vue&type=style&index=0&id=6a7c8301&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7c8301",
  null
  
)

export default component.exports